import ReviewHome from "./components/tutorReview/reviewHome.js";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Signin from "./components/signin.js";
import Success from "./components/success/reviewSuccess.js";
import SignupSuccess from "./components/success/signupSuccess.js";
import TutorSignup from "./components/tutorSignup/tutorSignup.js";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import TutorHome from "./components/tutorHome.js";
import { fetchThisUserData, fetchThisTutorData } from "./utils/fetchData.js";
import Profile from "./components/profile/profile.js";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      }
    });
  });

  useEffect(() => {
    if (user) {
      fetchThisUserData();
      fetchThisTutorData();
    }
  }, [user]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TutorHome user={user} />} />
        <Route path="/my-profile" element={<Profile user />} />
        <Route path="/review-tutor" element={<ReviewHome />} />
        <Route path="/login" element={<Signin />} />
        <Route path="/review-success" element={<Success user={user} />} />
        <Route path="/signup-success" element={<SignupSuccess user={user} />} />
        <Route path="/become-tutor" element={<TutorSignup user={user} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
